import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnleitungenPageComponent } from './anleitungen-page/anleitungen-page.component';
import { MaterialModule } from '../common/material/material.module';
import { AnleitungenListComponent } from './anleitungen-list/anleitungen-list.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AnleitungenUploadComponent } from './anleitungen-upload/anleitungen-upload.component';
import { WestnetzModule } from '../common/westnetz/westnetz.module';
import { FileUploadComponent } from '../common/file-upload/file-upload.component';

@NgModule({
    declarations: [
        AnleitungenPageComponent,
        AnleitungenListComponent,
        AnleitungenUploadComponent,
    ],
    imports: [
        CommonModule,
        MaterialModule,
        ReactiveFormsModule,
        WestnetzModule,
        FileUploadComponent,
    ],
})
export class AnleitungenModule {
}
